// actionTypes.js
export const SET_VALUE_INVESTISSEUR = "SET_VALUE_INVESTISSEUR";
export const SET_CURRENT_PAGE_INVESTISSEUR = "SET_CURRENT_PAGE_INVESTISSEUR";
export const SET_ORDER_INVESTISSEUR = "SET_ORDER_INVESTISSEUR";
export const SET_SORT_FIELD_INVESTISSEUR = "SET_SORT_FIELD_INVESTISSEUR";
export const SET_PAGE_SIZE_INVESTISSEUR = "SET_PAGE_SIZE_INVESTISSEUR";
export const SET_CUSTOM_FILTERS_INVESTISSEUR =
  "SET_CUSTOM_FILTERS_INVESTISSEUR";
export const SET_SORTING_INVESTISSEUR = "SET_SORTING_INVESTISSEUR";
export const SET_ACTIVE_TAB_INVESTISSEUR = "SET_ACTIVE_TAB_INVESTISSEUR";
export const SET_QUERY_INVESTISSEUR = "SET_QUERY_INVESTISSEUR";
export const SET_ACTIF_INVESTISSEUR = "SET_ACTIF_INVESTISSEUR";
export const SET_SELECTED_OPTION_FILTERS_INVESTISSEUR =
  "SET_SELECTED_OPTION_FILTERS_INVESTISSEUR";
export const SET_SELECTED_OPTION_ID_INVESTISSEUR =
  "SET_SELECTED_OPTION_ID_INVESTISSEUR";
export const SET_COLUMN_INVESTISSEUR = "SET_COLUMN_INVESTISSEUR";
